/** The hamburger icon. */
const IconHamburger = (): React.ReactElement => {
  return (
    <>
      <rect x="20%" y="30%" width="60%" height="1.8" fill="currentColor" />
      <rect x="20%" y="50%" width="60%" height="1.8" fill="currentColor" />
      <rect x="20%" y="70%" width="60%" height="1.8" fill="currentColor" />
    </>
  );
};

export default IconHamburger;
